import styles from './LoadingDialog.module.css'
import { CircularProgress, Dialog } from "@mui/material"

interface LoadingDialogProps {
    open: boolean,
    onClose?: (event: any) => void
    onOk?: (event: any) => void
    container?: Element
}

export const LoadingDialog = (props: LoadingDialogProps): JSX.Element => {
    const {
        open,
        onClose,
        onOk,
        container,
    } = props

    return (
        <>
            <Dialog
                open={open}
                container={container}
            >
                <div className={styles.LoadingDialog__Content}>
                    <h1 className={styles.LoadingDialog__Heading1}>Collecting market data <br/> In Real Time <br/> Please Wait...</h1>
                    <div><CircularProgress size={40} /></div>
                </div>
         
            </Dialog>
        </>
    )
}